export default __webpack_public_path__ + "static/help_06_05_5-cd0da1ee36467190845aaf5b7d41c7d0.png";